import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { User } from '~/api/types';
import { RootState } from '~/redux';

type CurrentUserState = {
  data: User | null;
  isLoading: boolean;
};

const initialState: CurrentUserState = {
  data: null,
  isLoading: false,
};

const currentUserSlice = createSlice({
  name: 'currentUser',
  initialState,
  reducers: {
    setCurrentUser: (state, action: PayloadAction<User>) => {
      state.data = action.payload;
    },
    clearCurrentUser: (state) => {
      state.data = null;
    },
    setCurrentUserLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setCurrentUser, clearCurrentUser, setCurrentUserLoading } = currentUserSlice.actions;
export const selectCurrentUser = (state: RootState) => state.currentUser.data;
export const selectCurrentUserId = (state: RootState) => state.currentUser.data?.id;
export const selectCurrentUserApplicationRole = (state: RootState) => state.currentUser.data?.role?.id;
export const selectCurrentUserIsAdmin = (state: RootState) => state.currentUser.data?.is_admin;
export const selectCurrentUserLoading = (state: RootState) => state.currentUser.isLoading;

export default currentUserSlice.reducer;
